import React, { FC, useEffect, useState } from 'react';
import { Swiper } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import { MTools } from '@/components';
import Title from '../Title';
import classnames from 'classnames';
import { getTopicList, getActivityList } from '@/services/service';
import styles from './index.less';

interface ComProps {

}

interface ListItemType {
  [key: string]: any;
}

const ClassRoom: FC<ComProps> = ({

}) => {
  const [list, setList] = useState<ListItemType[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(1);
  const [topicId, setTopicId] = useState<string | null>(null);

  useEffect(() => {
    handleGetTopicList();
  }, []);

  const handleIndexChange = (_index: number) => {
    setCurrentIndex(_index);
  }

  // 跳转云课堂列表
  const handleGoToClassRoom = () => {
    MTools.Url.gotoUrl(`/app/cloudClassroom`);
  }

  const handleGetTopicList = async () => {
    const result = await getTopicList({
      title: '网络安全云课堂'
    });
    if (result.success) {
      const _useList = result.data?.filter((i: any) => i.title === '网络安全云课堂') ?? [];
      if (_useList.length > 0 && _useList[0].status === 1) {
        handleGetActivityList(_useList[0].id);
      }
    } else {
      MTools.Tips('error', '系统异常，请刷新再试');
    }
  }

  const handleGetActivityList = async (_id: string) => {
    setTopicId(_id);
    const result = await getActivityList({
      topicId: _id,
    });
    if (result.success) {
      const _list = (result.data || []).filter((i: ListItemType) => i.status === 1);
      const _temList = _list.length > 5 ? _list.slice(0, 5) : _list;
      setList(_temList);
    } else {
      MTools.Tips('error', '系统异常，请刷新再试');
    }
  }

  const handleToDetail = (_id: string) => {
    MTools.Url.gotoUrl(`/app/cloudClassroomDetail/${_id}`);
  }

  return (
    <div className={styles.classroomWrapper}>
      <Title type={3} />
      <div className={styles.viewMoreW}>
        <div className={styles.viewMore} onClick={handleGoToClassRoom}>查看更多<RightOutline /></div>
      </div>

      <Swiper
        trackOffset={16.4}
        slideSize={67.2}
        defaultIndex={1}
        indicator={() => null}
        onIndexChange={handleIndexChange}
      >
        {
          list.map((item: any, _idx: number) => (
            <Swiper.Item key={item.id} onClick={() => handleToDetail(item.id)}>
              <div className={classnames(
                styles.itemInner,
                _idx === currentIndex - 1 ? styles.preItem : null,
                _idx === currentIndex + 1 ? styles.nextItem : null
              )}>
                <div className={styles.itemImg}>
                  <img src={item.cover} alt="" />
                </div>
                <div className={styles.itemText}>{item.title}</div>
              </div>
            </Swiper.Item>
          ))
        }
      </Swiper>
    </div>
  );
};

export default ClassRoom;
